import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Refresh(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 1c3.2 0 6.164 1.376 8.214 3.677V2.381a1 1 0 012 0v5.555l-.004.085.003.03.001.036v.04a.996.996 0 01-.003.067l.003-.087a1.01 1.01 0 01-.066.36l-.013.03a.893.893 0 01-.037.078l-.013.024a.91.91 0 01-.152.204l-.018.018a.924.924 0 01-.236.172.728.728 0 01-.047.023l-.028.012-.022.01a.993.993 0 01-.073.025l.095-.035a1.018 1.018 0 01-.208.063l-.027.004a.773.773 0 01-.073.01l-.05.002H15.66a1 1 0 110-2h3.898A8.985 8.985 0 0012 3c-4.962 0-9 4.037-9 9s4.038 9 9 9a8.957 8.957 0 008.595-6.323 1 1 0 111.91.594A10.95 10.95 0 0112 23.001C5.935 23 1 18.064 1 12 1 5.934 5.935 1 12 1z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoRefresh = React.memo(Refresh);
export default MemoRefresh;